import React from "react";
import UaeAboutHead from "../../UaeAttestation/UaeAbout/UaeAboutHead";
import PhilippinesAboutMain from "./PhilippinesAboutMain";

const PhilippinesAbout = () => {
  return (
    <div className="uaeAboutUsContainer">
      <UaeAboutHead head="About Philippines Attestation" />
      <PhilippinesAboutMain />
    </div>
  );
};

export default PhilippinesAbout;
